import icon_keypad_lock from '../assets/icon_keypad_locked.svg';
import icon_keypad_unlock from '../assets/icon_keypad_unlocked.svg';
import icon_alert from '../assets/icon_alert.svg';
import icon_fan from '../assets/icon_fan.svg';
import icon_heating from '../assets/icon_heating.svg';
import icon_cooling from '../assets/icon_cooling.svg';
import icon_idle from '../assets/icon_idle.svg';
import icon_eco from '../assets/icon_eco.svg';
import icon_off from '../assets/icon_state_off.svg';
import icon_more from '../assets/icon_more_vert.svg';
import icon_connectivity_problem from '../assets/icon_connectivity_problem.svg';
import icon_unmanaged from '../assets/icon_unmanaged.svg';
import icon_elexity from '../assets/icon_elexity.svg';
import icon_chevron from '../assets/icon_chevron.svg';
import icon_event_green from '../assets/icon_event_green.svg';

import icon_lock_locked from '../assets/icon_lock_locked.svg';
import icon_lock_unlocked from '../assets/icon_lock_unlocked.svg';
import icon_gear from '../assets/icon_gear.svg';

export const ICON = {
  STATUS: {},
  LOCK: {
    LOCKED: icon_lock_locked,
    UNLOCKED: icon_lock_unlocked,
  },
  ACTIVITY: {
    OFF: icon_off,
    HEATING: icon_heating,
    COOLING: icon_cooling,
    FAN: icon_fan,
    IDLE: icon_idle,
    ECONIMIZING: icon_eco,
    PROBLEM: icon_alert,
    PROBLEM_CONNECTIVITY: icon_connectivity_problem,
    UNMANAGED: icon_unmanaged,
    OFFLINE: icon_unmanaged,
    DEFAULT: icon_unmanaged,
  },
  CONTROL_MODE: {
    ELEXITY: icon_elexity,
    EVENT: icon_event_green,
    OVERRIDE: icon_gear,
    WARNING: icon_alert,
    UNMANAGED: icon_unmanaged,
    DEFAULT: icon_unmanaged,
  },
  UI: {
    CHEVRON: icon_chevron,
    MORE: icon_more,
  },
};
